import { IConfigsType } from '../../types'

const fwWingstopDailyOps: IConfigsType = {
  'fw_wingstop-corporate-base-zj8m1ewp': {
    '/:brand/ops_report': {
      variables: [
        {
          type: 'farwestNormalizeStatus',
          options: 'latestDataProcess',
        },
      ],
      groupFilter: {
        api: 'fwWingstopCorporateFilter',
      },
      dateFilter: {
        types: ['yesterday', 'this_week', 'last_week', 'week', 'custom'],
        defaultType: 'yesterday',
        isDailyCustom: true,
      },
      reportTitle: {
        type: 'title',
        title: 'Ops Report',
        subTitle: 'normalizationUpdatedAt',
      },
      downloadReport: {
        type: 'download-csv',
        api: 'farwestDailyOps',
        fileName: 'getexpo-far-west-daily-ops',
        message: 'Download as CSV',
        fields: [
          'groupInfo',
          {
            key: 'salesForecast',
            title: 'Sales Forecast',
          },
          {
            key: 'salesActual',
            title: 'Sales Actual',
          },
          {
            key: 'salesVariance',
            title: 'Sales Variance',
          },
          {
            key: 'splh',
            title: 'SPLH by Date',
          },
          {
            key: 'tplh',
            title: 'TPLH by Date',
          },
          {
            key: 'laborScheduledHours',
            title: 'Labor Scheduled Hours',
          },
          {
            key: 'laborActualHours',
            title: 'Labor Actual Hours',
          },
          {
            key: 'laborVarianceHours',
            title: 'Labor Variance Hours',
          },
          {
            key: 'otScheduledHours',
            title: 'OT Scheduled Hours',
          },
          {
            key: 'otActualHours',
            title: 'OT Actual Hours',
          },
          {
            key: 'laborScheduledPercent',
            title: 'Labor Scheduled Percent',
          },
          {
            key: 'laborActualPercent',
            title: 'Labor Actual Percent',
          },
          {
            key: 'laborVariancePercent',
            title: 'Labor Variance Percent',
          },
          {
            key: 'cashDeposit',
            title: 'Cash Deposit',
          },
          {
            key: 'cashOs',
            title: 'Cash O/S',
          },
          {
            key: 'totalCards',
            title: 'Total Cards',
          },
          {
            key: 'paidIn',
            title: 'Paid In',
          },
          {
            key: 'paidOut',
            title: 'Paid Out',
          },
          {
            key: 'checkAverage',
            title: 'Check Avg',
          },
          {
            key: 'refund',
            title: 'Refund $',
          },
          {
            key: 'voidSales',
            title: 'Void $',
          },
          {
            key: 'comps',
            title: 'Comps $',
          },
          {
            key: 'promos',
            title: 'Promos',
          },
          {
            key: 'netSales',
            title: 'Net Sales',
          },
          {
            key: 'classicCaseCountPerDay',
            title: 'Classic Case Count',
          },
          {
            key: 'tendersCaseCountPerDay',
            title: 'Tenders Case Count',
          },
          {
            key: 'bonelessCaseCountPerDay',
            title: 'Boneless Case Count',
          },
        ],
      },
      flashTablePart1: {
        type: 'table',
        api: 'farwestDailyOps',
        pageSize: 30,
        groupInfo: {
          width: '200px',
          groupBy: {
            width: '170px',
          },
        },
        summaryToTop: true,
        columns: [
          {
            key: 'salesForecast',
            title: 'Sales Forecast',
            sortable: true,
            highlight: true,
          },
          {
            key: 'salesActual',
            title: 'Sales Actual',
            sortable: true,
          },
          {
            key: 'salesVariance',
            title: 'Sales Variance',
            sortable: true,
            highlight: true,
          },
          {
            key: 'splh',
            title: 'SPLH by Date',
            sortable: true,
          },
          {
            key: 'tplh',
            title: 'TPLH by Date',
            decimal: 2,
            sortable: true,
          },
          {
            key: 'laborScheduledHours',
            title: 'Labor Scheduled Hours',
            decimal: 2,
            sortable: true,
            highlight: true,
          },
          {
            key: 'laborActualHours',
            title: 'Labor Actual Hours',
            decimal: 2,
            sortable: true,
          },
          {
            key: 'laborVarianceHours',
            title: 'Labor Variance Hours',
            decimal: 2,
            sortable: true,
            highlight: true,
          },
          {
            key: 'otScheduledHours',
            title: 'OT Scheduled Hours',
            decimal: 2,
            sortable: true,
          },
          {
            key: 'otActualHours',
            title: 'OT Actual Hours',
            decimal: 2,
            sortable: true,
            highlight: true,
          },
          {
            key: 'laborScheduledPercent',
            title: 'Labor Scheduled Percent',
            sortable: true,
          },
          {
            key: 'laborActualPercent',
            title: 'Labor Actual Percent',
            sortable: true,
            highlight: true,
          },
          {
            key: 'laborVariancePercent',
            title: 'Labor Variance Percent',
            sortable: true,
          },
        ],
      },
      flashTablePart2: {
        type: 'table',
        api: 'farwestDailyOps',
        pageSize: 30,
        groupInfo: {
          width: '200px',
          groupBy: {
            width: '170px',
          },
        },
        summaryToTop: true,
        columns: [
          {
            key: 'cashDeposit',
            title: 'Cash Deposit',
            sortable: true,
            highlight: true,
          },
          {
            key: 'cashOs',
            title: 'Cash O/S',
            sortable: true,
          },
          {
            key: 'totalCards',
            title: 'Total Cards',
            sortable: true,
            highlight: true,
          },
          {
            key: 'paidIn',
            title: 'Paid In',
            sortable: true,
          },
          {
            key: 'paidOut',
            title: 'Paid Out',
            sortable: true,
            highlight: true,
          },
          {
            key: 'checkAverage',
            title: 'Check Avg',
            decimal: 2,
            sortable: true,
          },
          {
            key: 'refund',
            title: 'Refund $',
            sortable: true,
            highlight: true,
          },
          {
            key: 'voidSales',
            title: 'Void $',
            sortable: true,
          },
          {
            key: 'comps',
            title: 'Comps $',
            sortable: true,
            highlight: true,
          },
          {
            key: 'promos',
            title: 'Promos',
            sortable: true,
          },
          {
            key: 'netSales',
            title: 'Net Sales',
            sortable: true,
            highlight: true,
          },
          {
            key: 'classicCaseCountPerDay',
            title: 'Classic Case Count Avg',
            sortable: true,
          },
          {
            key: 'tendersCaseCountPerDay',
            title: 'Tenders Case Count Avg',
            sortable: true,
            highlight: true,
          },
          {
            key: 'bonelessCaseCountPerDay',
            title: 'Boneless Case Count Avg',
            sortable: true,
          },
        ],
      },
      chatbox: {
        type: 'chatbox-v2',
        agentCode: 'daily-ops',
        sendStoreId: false,
      },
    },
  },
}

export default fwWingstopDailyOps
